import { getFlag, initializePostHog } from '@client/utils/feature-flags';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { ClipboardCheck } from 'lucide-react';

const FLAG_KEY = 'enable-compliance-audit';

// CUR-424 — admin-authored file-audit templates. The whole surface is gated by the
// existing enable-compliance-audit flag: `staticData.featureFlag` hides the nav
// entry, landing cards and tabs (useHasRouteAccess), this beforeLoad redirects
// direct visits, and the server is the authoritative gate (NOT_FOUND).
export const Route = createFileRoute('/admin-console/platform-content/compliance-audit-templates')({
    staticData: {
        permissions: ['admin_content:full'],
        featureFlag: FLAG_KEY,
        breadcrumb: { title: 'File audit templates' },
        ui: {
            icon: ClipboardCheck,
            title: 'File audit templates',
            menuDescription: 'Author and publish the file-audit templates assigned to organisations',
        },
    },
    beforeLoad: async (): Promise<void> => {
        // On a hard load this races PostHog init and the flag isn't in the anonymous
        // bootstrap — await init (cached promise, no-op once resolved) before reading.
        await initializePostHog();
        if (!(await getFlag(FLAG_KEY, false))) {
            throw redirect({ to: '/admin-console/platform-content', replace: true });
        }
    },
    component: Outlet,
});
